import { useState } from "react";
import axios from "axios";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ManageSubscription = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (state === "loading") return;
    setState("loading");
    try {
      await axios.post(`${API}/portal/request`, { email });
      setState("done");
    } catch {
      setState("done");
    }
  };

  return (
    <div
      data-testid="manage-page"
      className="min-h-screen bg-[#0A0A0A] text-white font-manrope grid-lines flex items-center justify-center px-6"
    >
      <div className="w-full max-w-lg border border-white/10 bg-[#121212] p-8 md:p-12">
        <img src="/breethe-logo.webp" alt="Breethe" className="h-7 w-auto" />
        <p className="mt-8 font-plex text-xs uppercase tracking-[0.25em] text-volt">
          Subscription Control
        </p>
        <h1 className="mt-3 font-anton uppercase text-4xl md:text-5xl leading-[0.9]">
          Your subscription<span className="text-volt">,</span>
          <br />
          your rules<span className="text-volt">.</span>
        </h1>

        {state === "done" ? (
          <p data-testid="manage-success-text" className="mt-6 text-white/60 font-light text-base md:text-lg">
            If that email has an active subscription, a manage link is on its way to your inbox.
            It works for 24 hours.
          </p>
        ) : (
          <>
            <p className="mt-4 text-white/60 font-light text-base">
              Enter the email you subscribed with. We'll send you a secure link to manage
              or cancel — no phone calls, no guilt trips.
            </p>
            <form onSubmit={onSubmit} className="mt-8">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="YOUR@EMAIL.COM"
                data-testid="manage-email-input"
                className="w-full h-14 bg-transparent border border-white/20 focus:border-volt px-5 font-plex text-sm uppercase tracking-[0.15em] placeholder:text-white/30 text-white outline-none transition-colors duration-300"
              />
              <button
                type="submit"
                disabled={state === "loading"}
                data-testid="manage-submit-button"
                className="group mt-4 w-full h-14 bg-volt text-black font-anton uppercase tracking-wider text-base flex items-center justify-center gap-3 transition-[background-color,transform] duration-200 hover:bg-volt-dark active:scale-[0.98] disabled:opacity-60"
              >
                {state === "loading" ? "Sending…" : "Email Me The Link"}
                <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </form>
          </>
        )}

        <a
          href="/"
          data-testid="manage-home-link"
          className="mt-8 inline-block font-plex text-xs uppercase tracking-[0.25em] text-white/40 hover:text-volt transition-colors duration-300"
        >
          ← Back to Breethe
        </a>
      </div>
    </div>
  );
};

export default ManageSubscription;
